import { Controller } from '@hotwired/stimulus';
import debounce from 'lodash/debounce';

// Submits the surrounding form while typing (family tree profile search, #4488): once the field holds
// `minLength` characters, or again when it is cleared so the default list comes back. Enter and the
// submit button keep working for shorter terms.
export default class extends Controller {
  static values = { minLength: { type: Number, default: 3 }, delay: { type: Number, default: 250 } };

  initialize() {
    this.submit = debounce(this.submit.bind(this), this.delayValue);
  }

  input(event) {
    const length = event.target.value.trim().length;
    if (length === 0 || length >= this.minLengthValue) this.submit();
  }

  submit() {
    this.element.requestSubmit();
  }
}
